import type { AdminTariff, BillingPeriod } from '../../utils/subscriptionApiUtils';

export const formatMoney = (amount: number, currency: string): string => {
  if (currency === 'RUB' || currency === 'RUR') {
    return `${amount.toLocaleString('ru-RU')} ₽`;
  }
  return `${amount.toLocaleString('ru-RU')} ${currency}`;
};

export const tariffPriceLabel = (tariff: AdminTariff, period: BillingPeriod): string => {
  if (period === 'monthly') {
    return `${formatMoney(tariff.price_monthly, tariff.currency)}/мес`;
  }
  return `${formatMoney(tariff.price_yearly_total, tariff.currency)}/год`;
};

export const tariffMonthlyEquivalent = (tariff: AdminTariff, period: BillingPeriod): string => {
  if (period === 'monthly') {
    return `${formatMoney(tariff.price_monthly, tariff.currency)}/мес`;
  }
  return `≈ ${formatMoney(tariff.price_yearly_monthly, tariff.currency)}/мес`;
};

export const protocolLimitLabel = (tariff: AdminTariff): string => {
  const unit = tariff.protocol_limit_period === 'monthly' ? 'месяц' : 'год';
  return `До ${tariff.protocol_limit} мед. протоколов в ${unit}`;
};
